

export default function searchText(haystack:string, needle:string) {

    return (haystack.toLowerCase().includes(needle.trim().toLowerCase()))

}